export default __webpack_public_path__ + "static/te_small-image_2-852ce09e5529561ae0408808286869df.png";